import { Infobars } from '../Infobars';
import { SESSION_INFOBAR_TYPE, withContainer } from './withContainer';

const SessionInfobars = withContainer(Infobars);

export {
  SESSION_INFOBAR_TYPE,
  SessionInfobars,
};
export * from './withContainer';
